export default "__VITE_ASSET__DtVsKhSw__"